import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FeatureIcons from "./sections/FeatureIcons";
import ExplanatoryText from "./sections/ExplanatoryText";
import Testimonials from "./sections/Testimonials";
import FAQ from "./sections/FAQ";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FeatureIcons />
      <ExplanatoryText />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>;
}